import * as FormUtils from './formUtils';
import {
  clickToCall,
  clickToCallLink,
  matchStatusChange,
  matchDeclineStatusChange,
  accept,
  toggleBlackoutReasonTextArea,
  applyShowDeclineTextArea,
  addMatchDeclineTextAreaChange,
} from '../pages/matches';

import toggleEventsTable from '../pages/referrals';

import {
  matchUpdateSubmit,
  copyAgentCommission,
  fileUploader,
  resetForm,
  submitReminderForm,
  toggleArchiveText,
  toggleButton,
  toggleEmailCheckbox,
  togglefileUploadButton,
  toggleFormFields,
  toggleReminderForm,
  toggleStateOptions,
  toggleTooltip,
  updatePropertyAddress,
} from '../pages/matches/update_status';

import validateSearch from '../pages/search';

import applyCounterForTextareas from '../pages/matches/decline';

import {
  progressDetailsExpandButtons,
  progressDetailsCheckCompletion,
} from '../pages/progress_report';

import selectFilter from './matches_and_referrals/selectFilter';

// missing forEach on NodeList for IE11
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}

const addClickToCallHandler = () => {
  const clickToCallButton = document.getElementById('click-to-call');
  if (clickToCallButton) {
    clickToCallButton.addEventListener('click', clickToCall);
  }
};

const addPhoneLinkeHandler = () => {
  const clickToCallButtons = document.querySelectorAll('.phone-link');

  clickToCallButtons.forEach((link) => {
    link.addEventListener('click', clickToCallLink);
  });
};

const addSearchHandler = () => {
  const searchInput = document.getElementById('search');
  if (searchInput) {
    searchInput.addEventListener('keyup', validateSearch);
  }
};

const addStatusSelectHandler = () => {
  const statusSelect = document.getElementById('status-select');
  if (statusSelect) {
    statusSelect.addEventListener('change', matchStatusChange);
  }
};

const addDeclineStatusSelectHandler = () => {
  const declineStatusSelect = document.getElementById('decline-status-select');
  if (declineStatusSelect) {
    declineStatusSelect.addEventListener('change', matchDeclineStatusChange);
  }
};

const addMatchAcceptHandler = () => {
  const matchAccept = document.getElementById('match-accept-submit');
  if (matchAccept) {
    matchAccept.addEventListener('click', accept, { once: true });
  }
};

const addToggleEventsTableHandler = () => {
  const headers = document.getElementsByClassName('timestamp-header');

  if (headers) {
    for (let i = 0; i < headers.length; i += 1) {
      headers[i].addEventListener('click', toggleEventsTable);
    }
  }
};

const addToggleForm = () => {
  const noteStatus = document.getElementById('note_status');
  const noteMessage = document.getElementById('note_message');

  if (noteStatus) {
    noteStatus.addEventListener('change', (e) => {
      toggleArchiveText();
      toggleButton();
      toggleFormFields();
      resetForm(e);
    });
  }

  if (noteMessage) {
    noteMessage.addEventListener('input', () => {
      toggleButton();
    });
  }
};

const addToggleTooltip = () => {
  const tooltipTogglers = document.querySelectorAll('.tooltip-toggler');

  if (tooltipTogglers.length) {
    tooltipTogglers.forEach((tooltipToggler) => {
      tooltipToggler.addEventListener('click', (e) => toggleTooltip(e));
    });
  }
};

const addToggleEmailCheckbox = () => {
  const emailToggler = document.querySelector('.email-checkbox-toggler');

  if (emailToggler) {
    emailToggler.addEventListener('click', (e) => {
      e.preventDefault();
      toggleEmailCheckbox(e);
    });
  }
};

const addFileUploader = () => {
  const uploader = document.querySelector('.file-uploader');

  if (uploader) {
    uploader.addEventListener('click', (e) => {
      e.preventDefault();
      fileUploader(e);
    });
  }
};

const addTogglefileUploadButton = () => {
  const uploader = document.querySelector('input[type="file"]');

  if (uploader) {
    uploader.addEventListener('change', (e) => togglefileUploadButton(e));
  }
};

const addPropertyAddressHandler = () => {
  const inputs = document.querySelectorAll('[name*="note[address]["]');

  if (inputs.length) {
    inputs.forEach((input) => {
      const eventType = (/INPUT/).test(input.tagName) ? 'keyup' : 'change';

      input.addEventListener(eventType, () => {
        updatePropertyAddress();
      });
    });
  }
};

const addToggleStateOptions = () => {
  const select = document.querySelector('[name="note[address][country]"]');

  if (select) {
    select.addEventListener('change', (e) => toggleStateOptions(e));
  }
};

const addToggleBlockoutReason = () => {
  const blackoutDates = document.querySelectorAll('.date-fields input[type="date"]');

  if (blackoutDates.length) {
    blackoutDates.forEach((blackoutDate) => {
      blackoutDate.addEventListener('change', toggleBlackoutReasonTextArea);
    });
  }
};

const addCloseReminderForm = () => {
  const buttons = document.querySelectorAll('.cancel-upsert-reminder');

  if (buttons.length) {
    buttons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        toggleReminderForm(e, 'close');
      });
    });
  }
};

const addOpenReminderForm = () => {
  const reminders = document.querySelectorAll('.note-add-edit-reminder');

  if (reminders.length) {
    reminders.forEach((reminder) => {
      reminder.addEventListener('click', (e) => {
        toggleReminderForm(e, 'open');
      });
    });
  }
};

const addSubmitReminderForm = () => {
  const buttons = document.querySelectorAll('.upsert-reminder');

  if (buttons.length) {
    buttons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        submitReminderForm(e);
      });
    });
  }
};

const addCopyAgentCommission = () => {
  const nodes = document.querySelectorAll('.agent-commission:not(.original-commission)');

  if (nodes.length) {
    nodes.forEach((node) => {
      node.addEventListener('keyup', (e) => {
        copyAgentCommission(e);
      });
    });
  }
};

const addMaskedInputs = () => {
  const form = document.querySelector('form');

  if (form) {
    FormUtils.maskInputs(form);
  }
};

const addMatchUpdateSubmit = () => {
  const buttons = document.querySelectorAll('.match-update-submit');

  buttons.forEach((button) => {
    button.addEventListener('click', (e) => matchUpdateSubmit(e));
  });
};

const addEventListeners = () => {
  document.addEventListener('turbolinks:load', () => {
    setTimeout(() => {
      addMaskedInputs();
      addPhoneLinkeHandler();
      addClickToCallHandler();
      addCloseReminderForm();
      addCopyAgentCommission();
      addMatchUpdateSubmit();
      addDeclineStatusSelectHandler();
      addFileUploader();
      addMatchAcceptHandler();
      addOpenReminderForm();
      addPropertyAddressHandler();
      addSearchHandler();
      addStatusSelectHandler();
      addSubmitReminderForm();
      addToggleEventsTableHandler();
      addToggleEmailCheckbox();
      addTogglefileUploadButton();
      addToggleForm();
      addToggleStateOptions();
      addToggleTooltip();
      applyCounterForTextareas();
      progressDetailsExpandButtons();
      progressDetailsCheckCompletion();
      addToggleBlockoutReason();
      applyShowDeclineTextArea();
      addMatchDeclineTextAreaChange();
      selectFilter();
    }, 100);
  });
};

export default addEventListeners;
